function PaginationButton({ handleClick, disabled, value, icon }) {
	return (
		<span onClick={handleClick} data-value={value} className={`text-gray-500`} disabled={disabled}>{icon}</span>
	)
}

export default PaginationButton